const FLAVORS_ERROR = new Error('up.modal.flavors has been removed without direct replacement. You may give new layers a { class } or modify layer elements on up:layer:open.');
up.modal = {
    visit(url, options = {}) {
        up.migrate.deprecated('up.modal.visit(url)', 'up.layer.open({ url, mode: "modal" })');
        return up.layer.open(Object.assign(Object.assign({}, options), { url, mode: 'modal' }));
    },
    follow(link, options = {}) {
        up.migrate.deprecated('up.modal.follow(link)', 'up.follow(link, { layer: "modal" })');
        return up.follow(link, Object.assign(Object.assign({}, options), { layer: 'modal' }));
    },
    extract(target, html, options = {}) {
        up.migrate.deprecated('up.modal.extract(target, document)', 'up.layer.open({ document, mode: "modal" })');
        return up.layer.open(Object.assign(Object.assign({}, options), { target, html, layer: 'modal' }));
    },
    close(options = {}) {
        up.migrate.deprecated('up.modal.close()', 'up.layer.dismiss()');
        up.layer.dismiss(null, options);
        return up.migrate.formerlyAsync('up.layer.dismiss()');
    },
    url() {
        up.migrate.deprecated('up.modal.url()', 'up.layer.location');
        return up.layer.location;
    },
    coveredUrl() {
        var _a;
        up.migrate.deprecated('up.modal.coveredUrl()', 'up.layer.parent.location');
        return (_a = up.layer.parent) === null || _a === void 0 ? void 0 : _a.location;
    },
    get config() {
        up.migrate.deprecated('up.modal.config', 'up.layer.config.modal');
        return up.layer.config.modal;
    },
    contains(element) {
        up.migrate.deprecated('up.modal.contains()', 'up.layer.contains()');
        return up.layer.contains(element);
    },
    isOpen() {
        up.migrate.deprecated('up.modal.isOpen()', 'up.layer.isOverlay()');
        return up.layer.isOverlay();
    },
    get flavors() {
        throw FLAVORS_ERROR;
    },
    flavor() {
        throw FLAVORS_ERROR;
    }
};
up.migrate.renamedEvent('up:modal:open', 'up:layer:open');
up.migrate.renamedEvent('up:modal:opened', 'up:layer:opened');
up.migrate.renamedEvent('up:modal:close', 'up:layer:dismiss');
up.migrate.renamedEvent('up:modal:closed', 'up:layer:dismissed');
up.migrate.targetMacro('up-modal', { 'up-layer': 'new modal' }, () => up.migrate.deprecated('[up-modal]', '[up-layer="new modal"]'));
up.migrate.targetMacro('up-drawer', { 'up-layer': 'new drawer' }, () => up.migrate.deprecated('[up-drawer]', '[up-layer="new drawer"]'));
